// extracted by mini-css-extract-plugin
module.exports = {"skill":"_17KjuvQSHNWjoW1u883yA3","image":"_3rbNKJs4OytM_z1PgT7Ltv","text":"_19G8d4eGzrfrJGRhUCY8qn"};